export interface KeywordTableColumn {
  type: KeywordTableColumnTypes;
  order?: number; // Undefined = not shown
  url?: boolean;
  traffic?: boolean;
  id?: number; // Used for domain, tag group
  size?: KeywordTableColumnSize;
  sizePx?: number;
}

export enum KeywordTableColumnSize {
  none = 'none',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export enum KeywordTableColumnTypes {
  Keyword = 0,
  EnglishTranslation = 1,
  TranslationFrom = 2,
  TranslationFromVolume = 3,
  ArchiveTime = 4,
  RankStatus = 5,

  // Origin
  SeedKeyword = 6,
  SeedType = 7,
  KeywordSearch = 8,

  // Stats
  Volume = 9,
  VolumeTrend = 10,
  // OriginalVolume = 11, // Legacy
  // OriginalVolumeShare = 12, // Legacy
  Cpc = 13,
  CpcBidHigh = 14,
  CpcBidLow = 15,
  Competition = 16,

  // Months
  VolumeLast12months = 17,
  VolumeMonthPeak = 18,
  VolumeQuarterPeak = 19,

  // Related
  Rank = 20,
  TagGroup = 21,
  SerpFeatures = 22,
  TagCount = 23,
}

export const monthNames = [
  { id: 1, name: 'Jan' },
  { id: 2, name: 'Feb' },
  { id: 3, name: 'Mar' },
  { id: 4, name: 'Apr' },
  { id: 5, name: 'May' },
  { id: 6, name: 'Jun' },
  { id: 7, name: 'Jul' },
  { id: 8, name: 'Aug' },
  { id: 9, name: 'Sep' },
  { id: 10, name: 'Oct' },
  { id: 11, name: 'Nov' },
  { id: 12, name: 'Dec' },
];
